import { Box, BoxProps, Typography } from '@mui/material';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import { FC } from 'react';

interface NoDataComponentProps extends BoxProps {
    label: string;
}

const NoDataComponent: FC<NoDataComponentProps> = ({ label, sx, ...props }) => {
    return (
        <Box
            sx={{
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                cursor: 'pointer',
                ...sx,
            }}
            {...props}
        >
            <Box textAlign={'center'}>
                <SearchOffIcon sx={{ width: 20, height: 20, color: 'action.disabled' }} />
                <Typography sx={{ fontSize: '0.75rem', color: 'text.disabled' }}>{label}</Typography>
            </Box>
        </Box>
    );
};
export default NoDataComponent;
